export default "/images/0cf09a2f2a69be83c829b41376e1c41c.avif";